import { giphyBlack, giphyLightGrey } from '@giphy/js-brand'
import { useContext, useMemo } from 'react'
import { useLocation } from 'react-router'
import { titleFont } from 'shared/components/text-elements'
import styled from 'styled-components'
import { CreationToolsContext } from '../manager'
import CreationToolStep from '../types/steps'
import { SquareButton } from './buttons'
import { Subtitle } from './typography'

const Container = styled.div`
    background: ${giphyBlack};
    bottom: 0;
    box-sizing: border-box;
    flex-grow: 0;
    flex-shrink: 0;
    padding: 15px 0;
    pointer-events: none;
    position: sticky;
    text-align: center;
    width: 100%;
`

const StepNumber = styled(SquareButton as any)`
    display: inline-block;
    font-family: ${titleFont};
    margin-right: 12px;
`

const Item = styled.div<{ active: boolean }>`
    color: ${({ active }) => (active ? '#fff' : giphyLightGrey)};
    display: inline-block;
    margin: 0 15px;

    ${Subtitle} {
        margin: 0;
    }

    ${StepNumber} {
        background: ${({ active }) => (active ? '#fff' : '#000')};
        color: ${({ active }) => (active ? '#000' : '#fff')};
    }
`

const CreationToolsBreadcrumbs = () => {
    const { steps } = useContext(CreationToolsContext)
    const { pathname } = useLocation()
    const activeStep = steps.find((step) => pathname.indexOf(CreationToolStep.route(step)) > -1)
    const filteredSteps = useMemo(() => steps.filter((step) => step !== CreationToolStep.BetaPicker), [steps])

    return steps.length > 1 ? (
        <Container>
            {filteredSteps.map((step, i) => {
                const label = CreationToolStep.label(step)
                return (
                    <Item key={step} active={step === activeStep}>
                        <StepNumber>{i + 1}</StepNumber>
                        <Subtitle as="span">{label}</Subtitle>
                    </Item>
                )
            })}
        </Container>
    ) : null
}

export default CreationToolsBreadcrumbs
